import { FortemSDKError } from '../shared/errors';
import { responseTypes } from './constants';
const isJsonContentType = (contentType) => {
    const value = contentType?.toLowerCase();
    return value?.includes('application/json') || value?.includes('+json') || false;
};
export const parseResponse = async (response, responseType) => {
    if (responseType === responseTypes.Text) {
        return (await response.text());
    }
    if (responseType === responseTypes.Blob) {
        return (await response.blob());
    }
    if (responseType === responseTypes.ArrayBuffer) {
        return (await response.arrayBuffer());
    }
    if (response.status === 204) {
        return undefined;
    }
    if (!isJsonContentType(response.headers.get('content-type'))) {
        throw new FortemSDKError('Expected JSON response.', 'UNEXPECTED_CONTENT_TYPE', response.status);
    }
    const json = (await response.json().catch(() => null));
    if (!json) {
        throw new FortemSDKError('Invalid JSON response.', 'INVALID_JSON_RESPONSE', response.status);
    }
    if (json.success) {
        return json.data;
    }
    throw new FortemSDKError(json.error.message, json.error.code, response.status, json.error.detail);
};
